const landing2 = () => {
  const swiperExploreLanding = () => {
    new Swiper('.swiper-explore-landing', {
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      autoplay: {
        delay: 3000,
      },
      scrollbar: {
        el: '.section-landing-top-banner .swiper-scrollbar',
      },
      navigation: {
        nextEl: '.section-landing-top-banner .swiper-button-next',
        prevEl: '.section-landing-top-banner .swiper-button-prev',
      },
      breakpoints: {
        400: {
          slidesPerView: 1.8,
          spaceBetween: 20,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 2.8,
          spaceBetween: 20,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
        920: {
          slidesPerView: 3.4,
          spaceBetween: 20,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
        1367: {
          slidesPerView: 4.6,
          spaceBetween: 30,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
      }
    });
  }

  const splideRating = () => {
    new Swiper('.swiper-rating', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      slidesPerGroup: 1,
      autoplay: {
        delay: 4000,
      },
      pagination: false,
      navigation: false,
      breakpoints: {
        500: {
          slidesPerView: 1.8,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 35,
        },
        1280: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 35,
        },
      }
    });
  }

  const swiperExploreThink = () => {
    new Swiper('.swiper-explore-think', {
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      autoplay: {
        delay: 3000,
      },
      scrollbar: {
        el: '.section-we-think-landing .swiper-scrollbar',
      },
      navigation: {
        nextEl: '.section-we-think-landing .swiper-button-next',
        prevEl: '.section-we-think-landing .swiper-button-prev',
      },
      breakpoints: {
        400: {
          slidesPerView: 1.8,
          spaceBetween: 20,
          slidesOffsetBefore: 30,
          slidesOffsetAfter: 30,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 2.8,
          spaceBetween: 20,
          slidesOffsetBefore: 30,
          slidesOffsetAfter: 30,
          centeredSlides: false,
        },
        920: {
          slidesPerView: 3.4,
          spaceBetween: 20,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
        1367: {
          slidesPerView: 4.6,
          spaceBetween: 30,
          slidesOffsetBefore: 60,
          slidesOffsetAfter: 60,
          centeredSlides: false,
        },
      }
    });
  }

  swiperExploreLanding()
  splideRating()
  swiperExploreThink()
}

const headerLanding = () => {
  const header = $('.header-landing')

  let scrollValue = 0
  window.addEventListener('scroll', () => {
    if (window.scrollY >= 50) {
      header.addClass('active')
    } else {
      header.removeClass('active')
    }
    if (scrollValue > window.scrollY) {
      header.fadeIn('fast')
    } else {
      header.fadeOut('fast')
    }
    scrollValue = window.scrollY
  })
}

const copyCode = async () => {
  const copy = $('.copy-code')
  copy.click(async function () {
    try {
      await navigator.clipboard.writeText(copy.text());
    } catch(e) {
      console.log(e)
    }
  })
}

const numberItemIcons = () => {
  const items = $('.section-landing-icons .items')
  const length = items.find('.item').length
  items.addClass(`items-length-${length}`)
}

$(document).ready(function() {
  landing2()
  headerLanding()
  copyCode()
  splideWave()
  numberItemIcons()
})
